import React from 'react';
import { Card } from 'react-bootstrap';

import pdfIcon from '../../../assets/pdf-logo.png';
import downloadIcon from '../../../assets/download.svg';

interface Props {
  filename: string;
  download: () => void;
}

const PdfFileCard = ({ filename, download }: Props) => (
  <Card style={{ width: '160px' }}>
    <Card.Body style={{ padding: '35px 45px' }}>
      <Card.Img src={pdfIcon} height="78px" width="68px" />
    </Card.Body>
    <Card.Footer className="d-flex align-items-center justify-content-between">
      <span 
        className="mb-0" 
        title={filename} 
        // @ts-ignore
        style={{ maxWidth: '120px', overflow: 'hidden', textWrap: 'nowrap', textOverflow: 'ellipsis' }}
      >
        {filename}
      </span>

      <img
        className="icon"
        src={downloadIcon}
        height="24px"
        alt="download"
        role="presentation"
        onClick={download}
      />
    </Card.Footer>
  </Card>
);

export default PdfFileCard;
